import { api } from './client';

export interface BackendUser {
  user_id: string;
  first_name: string;
  last_name: string;
  email: string;
  role?: string;
  company?: string;
  enabled?: boolean;
  created_at?: string;
  updated_at?: string;
  login_date?: string;
}

export interface NewUser {
  first_name: string;
  last_name: string;
  email: string;
  password?: string;
  role?: string;
  company?: string;
}

export interface UpdateUser {
  user_id: string;
  first_name: string;
  last_name: string;
  email: string;
  role?: string;
  company?: string;
  enabled?: boolean;
}

export interface UsersListResponse {
  total_count: number;
  total_pages: number;
  page: number;
  size: number;
  has_more: boolean;
  users: BackendUser[];
}

export interface UsersQueryParams {
  page?: number;
  size?: number;
  search?: string;
}

export const usersApi = {
  // Get current user info from backend
  getMe: () => api.get<BackendUser>('/auth/get_me'),

  // Get all users with pagination (admin only)
  getUsers: (params?: UsersQueryParams) => {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.size) queryParams.append('size', params.size.toString());
    if (params?.search) queryParams.append('search', params.search);

    return api.get<UsersListResponse>(`/auth/all?${queryParams.toString()}`);
  },

  // Get user by ID (admin only)
  getUser: (userId: string) => api.get<BackendUser>(`/auth/${userId}`),

  // Find users by name (admin only)
  findByName: (name: string) =>
    api.get<BackendUser[]>(`/auth/find?name=${encodeURIComponent(name)}`),

  // Create new user (admin only)
  createUser: (userData: NewUser) => api.post<BackendUser>('/auth/register', userData),

  // Update user (admin only)
  updateUser: (userData: UpdateUser) => api.put<BackendUser>('/auth/update', userData),
};
